export * from "./Scenes";
export * from "./AllInOnePlayer";
export const Version = "1.0.0-rc.1";